import { render } from "./settingsComponent.vue?vue&type=template&id=3ff94159"
import script from "./settingsComponent.vue?vue&type=script&lang=js"
export * from "./settingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__